import * as React from 'react';
import { Field } from 'redux-form';

import Input from 'af-fields/Input';

import Radio from 'af-components/Controls/Radio';

import styles from './styles.module.scss';
import RateUpdateFM from '../../../../Resources/Material/List/Materials/BulkRateUpdateModal/formModel';

interface PropsForShipping { rateKey: 'shippingMarkup'; updateKey: 'updateShippingMarkup'; }
interface PropsForSales { rateKey: 'salesMarkup'; updateKey: 'updateSalesMarkup'; }
interface PropsForTax { rateKey: 'tax'; updateKey: 'updateTax'; }

interface OwnProps {
	title: string;
	rate: Nullable<number>;
	updateRate: boolean;
	levelWord: 'Company' | 'Job';
	change(field: string, value: unknown): void;
}

type Props = OwnProps & (PropsForShipping | PropsForSales | PropsForTax);

const RateInputChoice: React.FC<Props> = (props) => {
	const { title, rate, updateRate, rateKey, updateKey, levelWord, change } = props;

	const handleNewRateCheck = React.useCallback(() => {
		change(rateKey, 0);
		change(updateKey, true);
	}, [change, rateKey, updateKey]);

	const handleCompanyRateCheck = React.useCallback(() => {
		change(rateKey, null);
		change(updateKey, true);
	}, [change, rateKey, updateKey]);

	const handleNoChangeCheck = React.useCallback(() => {
		change(updateKey, false);
	}, [change, updateKey]);

	const isNewRate = updateRate && rate !== null;
	const isCompanyRate = updateRate && rate === null;
	const noChange = !updateRate;

	return (
		<div className={styles.RateInputChoice}>
			<div className={styles.title}>{title}&nbsp;<span className={styles.requiredTick}>*</span></div>
			<div className={`${styles.choiceLine} ${styles.radioChoiceWithInput}`}>
				<Radio checked={isNewRate} className={styles.newRateRadio} label="New Rate" onCheck={handleNewRateCheck} />
				<Field
					component={Input}
					disabled={!isNewRate}
					isStandalone={true}
					name={RateUpdateFM.field(rateKey)}
					type="number"
				/>
			</div>
			<div className={styles.choiceLine}><Radio checked={isCompanyRate} label={`Use ${levelWord} Rate`} onCheck={handleCompanyRateCheck} /></div>
			<div className={styles.choiceLine}><Radio checked={noChange} label="Don't Change" onCheck={handleNoChangeCheck} /></div>
		</div>
	);
};

export default RateInputChoice;
